<template>
    <div ref="diagram" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div class="move-box">
            <!-- //遮罩层 -->
            <div class="upmask"></div>
            <iframe frameborder="0" class="small" :src="
          'http://local.vrmaker.vip:38080/webrtc/index.html?' +($store.state.homeitem.apk?
          $store.state.homeitem.apk:$store.state.homeitem.monitoring.videoCode)
        ">
            </iframe>
            <!-- //遮罩层 -->
            <div class="Downmask"></div>
        </div>

        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span>全屏</span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <!-- <img src="@/assets/img/full_cancel.png" alt="取消全屏"> -->
            <span>取消全屏</span>
        </div>

        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="margin-right: 18px">宽屏</span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="kuan = false" style="right: 20rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="">取消宽屏</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "VideoHome",
        props: ["videoList"],
        data() {
            return {
                kuan: false,
                // 全屏
                isFull: false,
            };
        },

        computed: {
            kuanStyle() {
                if (this.kuan) {
                    return `
         width: 84%;
            height:90%;
            position: fixed;
             top: 6%;
            left: 14%;
            bottom: 0;
            right: 0;
            margin: auto;
            z-index: 9999;
          `;
                }
                return;
            }
        },
        methods: {
            onkuan() {
                this.kuan = true;
            },
            full() {
                this.isFull = true;
            },
            cancelFull() {
                this.isFull = false;
            },
        },
        beforeDestroy() {
            this.$store.commit("apkAll", null);
        }
    };
</script>

<style lang="less" scoped>
    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;

    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background-color: rgba(0, 0, 0, 0);

    }

    .detail {
        font-size: 18rem;
        color: #fff;
        position: absolute;
        top: 24rem;
        left: 24rem;


        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .tableContainer {
        // .w(1473);
        // .h(705);

        z-index: 9999;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #000000;


    }

    .small {
        width: 80%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        //  z-index:9999
    }

    .mask {
        width: 100%;
        height: 100%;

    }

    .btn {
        // .wh(0, -36);
        // position: absolute;
        // top: @h;
        // right: @w;
        position: absolute;
        bottom: 22rem;
        right: 24rem;

        color: #ffffff;
        font-size: 20rem;
        cursor: pointer;

    }

    .upmask {
        height: 90rem;
        position: absolute;
        width: 100%;
        z-index: 9;
        background-image: linear-gradient(rgb(0, 0, 0, 1), rgba(0, 0, 0, 0));

    }

    .Downmask {
        height: 70rem;
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 0;
        background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 1));
    }
</style>